import { MetricType } from "./metricsType";

export enum MetricSource {
  detailed = "detailed",
  aggregated = "aggregated",
}

export interface AvailableMetricListResponse {
  availableMetrics: AvailableMetricResponse[];
  totalCount: Number;
}

export interface AvailableMetricResponse {
  metricName: MetricType;
  metricType: MetricSource;
  endpoint: string;
  implemented: boolean;
  totalCount: number;
}

export enum Platform {
  android = "android",
  ios = "ios",
  web = "web",
}

export interface MetricRequest {
  // Фильтрация по названиям кнопок (множественные значения с логикой OR)
  button_name?: ButtonName[];
  // Фильтрация по ID каталогов (множественные значения с логикой OR)
  catalog_id?: string[];
  // Фильтрация по ID категорий (множественные значения с логикой OR)
  category_id?: string[];
  // Фильтрация по городам (множественные значения с логикой OR)
  city?: string[];
  // Фильтрация по ID городов (множественные значения с логикой OR)
  city_id?: string[];
  // Фильтрация по способам контакта (множественные значения с логикой OR)
  contact_method?: ContactType[];
  // Фильтрация по странам (множественные значения с логикой OR)
  country?: string[];
  // Фильтрация по ID стран (множественные значения с логикой OR)
  country_id?: string[];
  // Начальная дата для фильтрации (YYYY-MM-DD)
  date_from?: string;
  // Конечная дата для фильтрации (YYYY-MM-DD)
  date_to?: string;
  // Число элементов на страницу
  limit?: number;
  // Начальный месяц (формат YYYY-MM), конвертируется в диапазон дат
  month_from?: string;
  // Конечный месяц (формат YYYY-MM), конвертируется в диапазон дат
  month_to?: string;
  // Сдвиг пагинации
  offset?: number;
  // Фильтрация по названиям опций (множественные значения с логикой OR)
  option_title?: string[];
  // Обратное направление задается знаком '-' перед названием поля
  order_by?: string;
  // Фильтрация по платформам (множественные значения с логикой OR)
  platform?: Platform[];
  // Фильтрация по названиям экранов (множественные значения с логикой OR)
  screen_name?: Screen[];
  // Фильтрация по времени суток (множественные значения с логикой OR)
  time_of_day?: TimeOfDay[];
  // Фильтрация по использованию подсказки (true/false)
  used_hint?: boolean;
  // Фильтрация по типам пользователей (множественные значения с логикой OR)
  user_type?: MetricsUserType[];
  // Filter by source screen names
  fromScreenName?: ScreenName[];
  // Filter by target screen names
  toScreenName?: ScreenName[];
  // Filter by action types
  actionType?: ActionType[];
}

export interface MetricDataResponse {
  data: any[];
  totalCount: number;
}

export enum ScreenName {
  HOME = "home",
  SEARCH_FILTERS = "searchFilters",
  SEARCH_RESULT = "searchResult",
  CHAT = "chat",
  AD_DETAILS = "adDetails",
  DEAL_CONFIRM = "dealConfirm",
  PROFILE = "userProfile",
  REVIEWS = "reviews",
}

export enum ActionType {
  CLICK_ON_BANNER = "clickOnBanner",
  CLICK_ON_TILE = "clickOnTile",
}

export enum ButtonName {
  FILTER = "filter",
  RECOMMENDATIONS = "recommendations",
  FAVORITES = "favorites",
  SUBSCRIPTIONS = "subscriptions",
  NEAREST = "nearest",
  SEARCH_BOTTOM_TAB = "searchBottomTab",
  FORUM_BOTTOM_TAB = "forumBottomTab",
  ADS_BOTTOM_TAB = "adsBottomTab",
  MESAGES_BOTTOM_TAB = "mesagesBottomTab",
  PROFILE_BOTTOM_TAB = "profileBottomTab",
}

export function getButtonName(button: ButtonName): string {
  const buttonNames: Record<ButtonName, string> = {
    [ButtonName.FILTER]: "Filter",
    [ButtonName.RECOMMENDATIONS]: "Recommendations",
    [ButtonName.FAVORITES]: "Favorites",
    [ButtonName.SUBSCRIPTIONS]: "Subscriptions",
    [ButtonName.NEAREST]: "Nearest",
    [ButtonName.SEARCH_BOTTOM_TAB]: "Search Bottom Tab",
    [ButtonName.FORUM_BOTTOM_TAB]: "Forum Bottom Tab",
    [ButtonName.ADS_BOTTOM_TAB]: "Ads Bottom Tab",
    [ButtonName.MESAGES_BOTTOM_TAB]: "Messages Bottom Tab",
    [ButtonName.PROFILE_BOTTOM_TAB]: "Profile Bottom Tab",
  };

  return buttonNames[button];
}

export enum PlatformResponse {
  android = "ANDROID",
  ios = "IOS",
  web = "WEB",
}

export function getPlatformName(platform: PlatformResponse): string {
  const platformNames: Record<PlatformResponse, string> = {
    [PlatformResponse.android]: "Android",
    [PlatformResponse.ios]: "iOS",
    [PlatformResponse.web]: "Web",
  };

  return platformNames[platform];
}

export enum TimeOfDay {
  NIGHT = "night",
  MORNING = "morning",
  DAY = "day",
  EVENING = "evening",
}

export function getTimeOfDayName(time: TimeOfDay): string {
  const timeNames: Record<TimeOfDay, string> = {
    [TimeOfDay.NIGHT]: "Ночь",
    [TimeOfDay.MORNING]: "Утро",
    [TimeOfDay.DAY]: "День",
    [TimeOfDay.EVENING]: "Вечер",
  };

  return timeNames[time];
}

export enum Hint {
  withHint = "withHint",
  withoutHint = "withoutHint",
}

export function getHintName(hint: Hint): string {
  const hintNames: Record<Hint, string> = {
    [Hint.withHint]: "С подсказкой",
    [Hint.withoutHint]: "Без подсказки",
  };

  return hintNames[hint];
}

export enum ContactType {
  chat = "chat",
  phone = "phone",
}

export function getContactTypeName(contact: ContactType): string {
  const contactNames: Record<ContactType, string> = {
    [ContactType.chat]: "Чат",
    [ContactType.phone]: "Телефон",
  };

  return contactNames[contact];
}

export enum ContactResponseType {
  chat = "chat",
  call = "call",
  whatsapp = "whatsapp",
  viber = "viber",
  telegram = "telegram",
}

export function getContactResponseTypeName(
  contact: ContactResponseType
): string {
  const contactNames: Record<ContactResponseType, string> = {
    [ContactResponseType.chat]: "Чат",
    [ContactResponseType.call]: "Телефон",
    [ContactResponseType.whatsapp]: "Whatsapp",
    [ContactResponseType.viber]: "Viber",
    [ContactResponseType.telegram]: "Telegram",
  };
  return contactNames[contact];
}

export enum MetricsUserType {
  buyer = "buyer",
  seller = "seller",
}

export function getUserTypeName(user: MetricsUserType): string {
  const userNames: Record<MetricsUserType, string> = {
    [MetricsUserType.buyer]: "Покупатель",
    [MetricsUserType.seller]: "Продавец",
  };

  return userNames[user];
}
